import { render } from "./serviceReview.vue?vue&type=template&id=5bf1c56e"
import script from "./serviceReview.vue?vue&type=script&lang=js"
export * from "./serviceReview.vue?vue&type=script&lang=js"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__